import { render, staticRenderFns } from "./NewPageObject.vue?vue&type=template&id=0e7a5b9c&scoped=true&"
import script from "./NewPageObject.vue?vue&type=script&lang=ts&"
export * from "./NewPageObject.vue?vue&type=script&lang=ts&"
import style0 from "./NewPageObject.vue?vue&type=style&index=0&id=0e7a5b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7a5b9c",
  null
  
)

export default component.exports